import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import Button from 'react-bootstrap/Button';
import qs from 'qs';
import Dots from 'react-activity/lib/Dots';
import SearchResults from '../common/searchResults';
import {getSearchResults} from '../../services/manufacturerService';
import {getCurrentUser} from '../../services/authService';

class ManufacturerResults extends Component {
    state = {
        data: {
            manufacturer_fullname:"",
            years_active: "",
            country_of_origin: "",
            aircraft_name: "",
            primary_group_id: 0,
            media_id: 0,
            scale_id: 0,
            brands: "",
            kitmolds: "",
            currentPage: 1,
            pageSize: 10,
           },
        manufacturers: [],
        itemsCount:0,
        keyColumn: "manufacturer_id",
        loaded: true
    }

    columns = [
        {
          path: "manufacturer_fullname",
          label: "Brand",
          icon: "tools",
          content: result => <Button variant="link" onClick={() => this.handleShowDetail(result.manufacturer_id)}>{result.manufacturer_fullname}</Button>
        },
        { path: "country_of_origin", label: "Country of Origin" , icon: "flag-usa"},
        { path: "years_active", label: "Years Active", icon: "calendar-alt" },
      ];
    
      deleteColumn = {
        key: "delete",
        content: result => (
          <button
            onClick={() => this.props.onDelete(result)}
            className="btn btn-danger btn-sm"
          >
            Delete
          </button>
        )
      };
    
      constructor() {
        super();
        const user = getCurrentUser();
        if (user && user.isAdmin) this.columns.push(this.deleteColumn);
      }

    async componentDidMount() {
        this.setState({loaded:false});

        const searchData = this.getlocalStorage();
        await this.loadResults(searchData);
    }

    async loadResults(data){
        const { manufacturers, itemsCount}  = await this.getPagedData(data);
    
        this.setState({ manufacturers, itemsCount, data, loaded:true })
    }

    getPagedData = async (data) => 
    {
        const queryString = this.getQueryString(data);
        const searchResults = await getSearchResults(queryString);

        const manufacturers = searchResults.manufacturers;
        const itemsCount = searchResults.totalCount;

        //console.log(manufacturers, totalCount, data);

        return { data, manufacturers, itemsCount };    
    }

    getQueryString(data){
        const criteriaString = qs.stringify(data);

        return criteriaString;
    }

    getlocalStorage() {
        const searchData = {};

        searchData.aircraft_name = localStorage.getItem('m_aircraft_name');
        searchData.manufacturer_fullname = localStorage.getItem('m_manufacturer_fullname');
        searchData.media_id = localStorage.getItem("m_media_id");
        searchData.scale_id = localStorage.getItem("m_scale_id");
        searchData.country_of_origin = localStorage.getItem("m_country_of_origin");
        searchData.primary_group_id = localStorage.getItem("m_primary_group_id");
        searchData.related_brands_logos = localStorage.getItem("m_brands");
        searchData.kitmolds = localStorage.getItem("m_kitmolds");
        searchData.years_active = localStorage.getItem("m_years_active");
        searchData.currentPage = parseInt(localStorage.getItem("m_currentPage"));
        searchData.pageSize = parseInt(localStorage.getItem("m_pageSize"));

        return searchData;
    }

    handlePageChange = async (page) => {
        const data = this.state.data;
        data.currentPage = page;

        const { manufacturers, itemsCount} = await this.getPagedData(data);
   
        this.setState({ manufacturers, itemsCount, data })
    }

    handleRefineSearch = () => {
        localStorage.setItem("m_currentPage", 1);
        this.props.history.push("/search/manufacturers")
    }

    handleShowDetail = (manufacturer_id) => {
        localStorage.setItem("m_currentPage", this.state.data.currentPage);
        this.props.history.push(`/manufacturer/details/${manufacturer_id}`);
    }

    render()
    {
        const { data, manufacturers, itemsCount, keyColumn, loaded } = this.state;

        let component;
        if(loaded === false)
          component = <div className="dots_loader"><Dots size={26} /></div>
        else
          component = <SearchResults data={data} results={manufacturers} columns={this.columns} keyColumn={keyColumn} 
                        itemsCount={itemsCount} usePageNumbers={false} doPageChange={this.handlePageChange} onRefineSearch={this.handleRefineSearch} 
                        onShowDetail={this.handleShowDetail}/>

        return (component);
    }
}
 
export default withRouter(ManufacturerResults);
